module.exports = __webpack_public_path__ + "static/media/Enviar(blanco).3b9eea41.svg";